import * as React from 'react';

import {
    useTranslation,
     G, useSearch,
} from '@components';
import {
    IWorker, ISecurity, IWork, ModuleManager
} from '@models';
import './RestrictWorker.scss';

interface IProps {
    security: ISecurity;
    moduleManager: ModuleManager;
    work: IWork;
    worker?: IWorker & { isRestrictedWorker?: boolean };
    restrictWorker: Function;
    handleToast: Function;
    onClose: { clearDialogs : Function, reload: Function};
    editRestriction: Function;
}

interface IResult {
    applicantEmail: string,
    applicantName: string,
    code: string,
    contractorId: number,
    contractorName: string,
    date: string,
    id: number,
    isActive: boolean,
    name: string,
    reason: string,
    surname: string,
    workId: number,
    remarks?: string,
    deactivatedAt?: string,
}

export function RestrictWorker(props: IProps) {
    const { t } = useTranslation();

    const [ disabled, setDisabled ] = React.useState(false);
    const [ canModify, setCanModify ] = React.useState<boolean>(false);

    const worker = useSearch<IResult>({
            workId: props.work.id,
            search: 'workers/restricted',
            filters: {
                workId: props.work.id,
                workerCode: props.worker?.code
            },
        });


    const calculateCanModify = () => {
        if (!props.worker?.isRestrictedWorker) {
            setCanModify(true);
        }
        if (props.security.isGestor()) {
            setCanModify(true);
        }
    }

    const initialize = () => {
        const restrictionData = worker.value[0];

        if (restrictionData) {
            setRestrictionId(restrictionData.id);
            setApplicantName(restrictionData.applicantName);
            setApplicantEmail(restrictionData.applicantEmail);
            setDate(restrictionData.date)
            setReason(restrictionData.reason);
            setRemarks(restrictionData.remarks ?? '');
        }
    }

    React.useEffect(() => {
        calculateCanModify();
        if(props.worker?.isRestrictedWorker) {
        worker.doSearch();
        }
    }, []);


    React.useEffect(() => {
        initialize();
    }, [worker.value]);

    const [ restrictionId, setRestrictionId ] = React.useState<number | undefined>(undefined);
    const [ applicantName, setApplicantName ] = React.useState<string>(props.security.user?.userName ?? '');
    const [ applicantEmail, setApplicantEmail ] = React.useState<string>(props.security.user?.email ?? '');
    const [ date, setDate ] = React.useState<string>(new Date().toISOString().split('T')[0]);
    const [ reason, setReason ] = React.useState<string>('');
    const [ remarks, setRemarks ] = React.useState<string>('');


    const handleSubmit = () => {
        if (props.worker?.isRestrictedWorker) {
            editRestriction();
        } else {
            handleSave();
        }
    }

    const handleSave = async () => {
        setDisabled(true);

        const resp = await props.restrictWorker(
            props.work.id,
            props.worker?.id,
            props.worker?.name,
            props.worker?.surname,
            props.worker?.code,
            props.worker?.contractorId,
            applicantName,
            applicantEmail,
            reason,
            remarks,
        );

        if (resp.restrictWorker.isError === false && typeof resp.restrictWorker.value == 'number') {
            props.handleToast(t('Worker restricted successfully'), true);
            props.onClose.reload(true);
            props.onClose.clearDialogs();
        } else {
            props.handleToast(t('Error restricting worker'), false);
            props.onClose.clearDialogs();
        }
    }

    const editRestriction = async ()  => {
        setDisabled(true);
        const response = await props.editRestriction(restrictionId, applicantName, applicantEmail, reason, remarks)

        if(response.data.editWorkerRestriction.isError || response.data.editWorkerRestriction.value == 0) {
            props.handleToast(t('Error while editing restriction'), false);
            props.onClose.clearDialogs();
        }else {
            props.handleToast(t('Restriction has been edited successfully'), true);
            props.onClose.reload(true);
            props.onClose.clearDialogs();
        }
    }

    return (
        <div className='restrict-worker-dialog'>
            <G label={t('Name')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.worker?.name}
                />
            </G>
            <G label={t('Surname')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.worker?.surname}
                />
            </G>
            <G label={t('workerCode')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.worker?.code}
                />
            </G>
            <G label={t('Contractor')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.worker?.contractorName}
                />
            </G>
            <G label={t('Applicant')}>
                <input
                    disabled={!canModify}
                    className='c'
                    type='text'
                    value={applicantName}
                    onChange={(e) =>  setApplicantName(e.target.value)}
                />
            </G>
            <G label={t('Applicant email')}>
                <input
                    disabled={!canModify}
                    className='c'
                    type='text'
                    value={applicantEmail}
                    onChange={(e) => setApplicantEmail(e.target.value)}
                />
            </G>
            <G label={t('Date')}>
                <input
                    disabled={restrictionId !== undefined}
                    className='c'
                    type='date'
                    value={date.split('T')[0]}
                    onChange={(e) => setDate(e.target.value)}
                />
            </G>
            <G label={t('Motive')} className='restriction-reason'>
                <textarea
                    disabled={!canModify}
                    className='c'
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </G>
            <G label={t('Remarks')} className='restriction-remarks'>
                <textarea
                    disabled={!canModify}
                    className='c'
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                />
            </G>
            <div className='c' />
            <div className='r'>
                <span className='e' />

                {canModify && <button
                    className='primary'
                    disabled={disabled}
                    onClick={handleSubmit}>
                    {t('Save')}
                </button>}
            </div>
        </div>
    )
}